export default __webpack_public_path__ + "static/media/ic_web_regisbpjs.cf3c442a.png";